export default "__VITE_ASSET__CzpkCfKL__"